import React from 'react';
import Tetris from './components/Tetris';
import './App.css';

const App: React.FC = () => (
  <div className="App">
    <Tetris />
  </div>
);

export default App;